import React from 'react'
import { Button, Result } from 'antd'
import { Link } from 'react-router-dom'
import { routePathCabinet } from '../logined/Cabinet'
import { pcDevelopers } from '../../api/utils'

export const DonateBuyError = (): React.ReactElement => (
	<Result
		status="error"
		title="Упс, что-то пошло не так!"
		subTitle="Если вы считаете, что это ошибка, то сообщите об этом нам."
		extra={[
			<Link to={routePathCabinet} key="personal-cabinet" style={{ textDecoration: 'none' }}>
				<Button>В личный кабинет</Button>
			</Link>,
			<a
				href={pcDevelopers}
				key="report-a-bug"
				target="_blank"
				rel="noopener noreferrer"
				style={{ textDecoration: 'none' }}
			>
				<Button color="primary" type="primary">Сообщить об ошибке</Button>
			</a>
		]}
	/>
)

export const routePathDonateBuyError = '/cabinet/donate/error'
